<script setup>
import { defineModel } from 'vue';
import { BModal, BButton,  } from 'bootstrap-vue-next'
const modal = defineModel()
</script>

<template>
    <BModal v-model="modal" centered> 
      <template #header>
          <h5 class="">{{ title }}</h5>
          <BButton
            variant="link"
            class="close"
            @click="modal = false"
          >
            <i class="ion ion-android-close"></i>
          </BButton>
      </template>
      <slot name="text"></slot>
      <slot name="body"></slot>
      <template #footer>
          <div class="d-flex justify-content-end">
              <BButton tton variant="primary" @click="$emit('handleAction')" class="mr-2">Yes</BButton>
              <BButton variant="danger" @click="modal = false">No</BButton>
          </div>
      </template>
    </BModal>
    
  </template>